import React from 'react'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';


const CartItem = ({item, handleUpdateCart, handleRemoveCart}) => {
  const url = (item.image===null 
    ? 'https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png'
    : item.image.url);

  return (
    <Card className='mt-4'>
        <div style={{ height: '250px', overflow: 'hidden' }}>
            <Card.Img src={url} style={{ height: '100%', objectFit: 'cover' }} />
        </div>
        <Card.Body className="d-flex flex-column">
            <Card.Title>{item.name} (${item.price.raw})</Card.Title>
            <div className='mb-2' style={{ display: 'flex', alignItems: 'center'}}>
                <p style={{ margin: '0 10px' }}>Quantity: </p>
                <Button className='mr-2' size="sm" variant="outline-dark" onClick={()=>{handleUpdateCart(item.id, item.quantity-1)}}>-</Button>
                <p style={{ margin: '0 10px' }}>{item.quantity}</p>
                <Button className='ml-2' size="sm" variant="outline-dark" onClick={()=>{handleUpdateCart(item.id, item.quantity+1)}}>+</Button>
            </div>
            <Button onClick={()=>{handleRemoveCart(item.id)}}>Remove</Button>
        </Card.Body>

    </Card>
  )
}

export default CartItem